<template>
  <div class="container">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne class="-margin-md">ご契約内容のご確認</HeadingOne>

    <section>
      <TableBox class="-members _mb-10 _mt-30">
        <TableBody>
          <TableRow>
            <TableHeader> ご利用限度額 </TableHeader>
            <TableData>
              {{ numberToCurrency(userData.loan_credit_limit) }}
            </TableData>
          </TableRow>
          <TableRow>
            <TableHeader> 契約年月日 </TableHeader>
            <TableData>
              {{ ymdDateFormat(userData.loan_disbursal_date) }}
            </TableData>
          </TableRow>
          <TableRow>
            <TableHeader> 契約の有効期限 </TableHeader>
            <TableData>
              {{ ymdDateFormat(userData.loan_maturity_date_current) }}
            </TableData>
          </TableRow>
          <TableRow>
            <TableHeader> お借り入れ利率(実質年率) </TableHeader>
            <TableData>
              {{ userData.loan_contractual_interest_rate }}%
            </TableData>
          </TableRow>
          <TableRow>
            <TableHeader> 毎月のご返済日※ </TableHeader>
            <TableData>
              {{ userData.contractual_repayment_cycle }}日
            </TableData>
          </TableRow>
          <TableRow>
            <TableHeader> ご返済方法 </TableHeader>
            <TableData>
              <!-- 口座引落しの場合 -->
              <template v-if="hasBank"
                >ご指定の金融機関口座からの引落し</template
              >
              <!-- それ以外の場合 -->
              <template v-else
                >セブン銀行スマホＡＴＭでの現金入金または当社指定口座へのお振り込み</template
              >
            </TableData>
          </TableRow>
          <TableRow>
            <TableHeader> 各種書面の交付方法 </TableHeader>
            <TableData>
              {{ displayDocumentDeliveryMethod }}
            </TableData>
          </TableRow>
        </TableBody>
      </TableBox>

      <small>※金融機関休業日の場合は翌営業日となります。</small>

      <BtngroupSingle class="-margin-lg">
        <BtnMain class="-main" router-name="mb020">
          ご契約締結書類一覧のご確認へ
        </BtnMain>
      </BtngroupSingle>

      <!--<notice-box class="-point">-->
      <!--<notice-header>-->
      <!--<h3 class="heading">口座登録のメリット</h3>-->
      <!--</notice-header>-->
      <!--<notice-body>-->
      <!--<ListGroup class="-normal _mb-20">-->
      <!--<ListItem class="-normal">お借り入れ、ご返済時の手数料は0円</ListItem>-->
      <!--<ListItem class="-normal">毎月のご返済日に、口座からの自動引落としになるため、毎月忘れずにご返済いただけます。</ListItem>-->
      <!--</ListGroup>-->
      <!--<p>口座情報の登録・変更は<btn-text routerName="mb021" class="-underline">こちら</btn-text></p>-->
      <!--</notice-body>-->
      <!--</notice-box>-->

      <!--<ListGroup class="-link _mb-sm-60 _mb-md-120">-->
      <!--<ListItem class="-link" routerName="mb021" target="_blank">口座情報の登録・変更はこちら</ListItem>-->
      <!--<ListItem class="-link" routerName="sv036" target="_blank">増枠をご希望のお客さまはこちら</ListItem>-->
      <!--</ListGroup>-->

      <CardGroups class="_mb-sm-40 _mb-md-60">
        <CardBox>
          <CardHeader>
            <BtnToggle collapse-target="accordion0" class="-plus">
              <h2 class="heading">
                お借り入れ・ご返済時に便利な口座登録について
              </h2>
            </BtnToggle>
          </CardHeader>
          <CollapseItem id="accordion0" accordion="accordion" :visible="true">
            <CardBody>
              <ListGroup class="-normal _mb-20">
                <ListItem class="-normal"
                  >お借り入れ時の口座への振込み手数料、ご返済時の口座からの引落し手数料は0円</ListItem
                >
                <ListItem class="-normal"
                  >毎月のご返済日に、口座からの自動引落としになるため、毎月忘れずにご返済いただけます。</ListItem
                >
              </ListGroup>
              <ListGroup class="-link">
                <ListItem class="-link" router-name="mb021"
                  >口座情報の登録・変更はこちら</ListItem
                >
              </ListGroup>
            </CardBody>
          </CollapseItem>
        </CardBox>
      </CardGroups>
    </section>
  </div>
  <!-- container -->
</template>

<script>
import { getUserDataLambdaInvoke } from "@/utils/LambdaHelper";
import { setMeta } from "@/utils/Meta";
import { numberToCurrency, ymdDateFormat } from "@/utils/Filter";
import { goToErrorPage } from "@/utils/Other";

import HeadingOne from "@/components/heading/HeadingOne";
import TableBox from "@/components/tables/TableBox";
import TableBody from "@/components/tables/TableBody";
import TableRow from "@/components/tables/TableRow";
import TableHeader from "@/components/tables/TableHeader";
import TableData from "@/components/tables/TableData";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BtnToggle from "@/components/button/BtnToggle";
import CardBody from "@/components/card/CardBody";
import CardBox from "@/components/card/CardBox";
import CardGroups from "@/components/card/CardGroups";
import CardHeader from "@/components/card/CardHeader";
import CollapseItem from "@/components/collapse/CollapseItem";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";

export default {
  name: "Mb019",
  components: {
    ListItem,
    ListGroup,
    BtnMain,
    BtngroupSingle,
    TableData,
    TableHeader,
    TableRow,
    TableBody,
    TableBox,
    HeadingOne,
    BtnToggle,
    CardBody,
    CardBox,
    CardGroups,
    CardHeader,
    CollapseItem,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "ご契約内容のご確認｜ご契約・お取引情報",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,ご契約内容,確認",
    });

    return {
      numberToCurrency,
      ymdDateFormat,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "mb001",
        },
        {
          text: "ご契約内容のご確認",
          active: true,
        },
      ],
      errors: null,
      inputAmount: "",
      userData: {
        bank_name: "",
        branch_name: "",
        loan_credit_limit: "",
        loan_disbursal_date: "",
        loan_maturity_date_current: "",
        loan_contractual_interest_rate: "",
        contractual_repayment_cycle: "",
        document_delivery_method: "",
      },
    };
  },
  computed: {
    hasBank() {
      return !!this.userData.bank_name && !!this.userData.branch_name;
    },
    displayDocumentDeliveryMethod() {
      switch (this.userData.document_delivery_method) {
        case "":
          return "電磁的交付";
        case "1":
          return "電磁的交付";
        case "2":
          return "郵送交付";
        case "3":
          return "郵送交付";
        case "4":
          return "郵送交付";
        default:
          return "";
      }
    },
  },
  mounted() {
    try {
      getUserDataLambdaInvoke()
        .then((res) => {
          for (let key in res) {
            if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key];
            }
          }
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
};
</script>

<style lang="scss">
@import "@/assets/stylesheets/styles";
.-underline {
  text-decoration: underline;
}
</style>
